<template>
    <div v-if="this.loadData">
        <div class="text-center">
            <i class="icofont-spinner"></i>
        </div>
    </div>
    <div
        v-else
        class="twlpb"
        :class="{ 'is-titles-active': isTitlesActive, 'is-tooltip-active': isTooltipActive }"
        @mouseover.prevent="onMouseOver"
        @mouseleave.prevent="onMouseLeave"
    >
        <div
            class="twlpb-stats no-gutter"
            :class="{
                'is-visible': stats.isVisible,
                'is-active': stats.isActive,
                'vertical-alignment': !stats.verticalAlignment,
            }"
        >
            <div class="twlpb-stat">
                <div class="twlpb-stat__number">
                    <span :style="timeEstimatedStyle">{{ timeEstimated }}</span>
                </div>

                <div class="twlpb-stat__title">
                    <span :style="fitTextStyle(trans('Estimated'))">{{ trans('Estimated') }}</span>
                </div>
            </div>

            <div class="twlpb-stat">
                <div class="twlpb-stat__number">
                    <span :style="timePlannedStyle">{{ timePlanned }}</span>
                </div>

                <div class="twlpb-stat__title">
                    <span :style="fitTextStyle(trans('Planned'))">{{ trans('Planned') }}</span>
                </div>
            </div>

            <div class="twlpb-stat">
                <div class="twlpb-stat__number">
                    <span :style="timeWorkedStyle">{{ timeWorked }}</span>
                </div>

                <div class="twlpb-stat__title">
                    <span :style="fitTextStyle(trans('Worked'))">{{ trans('Worked') }}</span>
                </div>
            </div>

            <div class="twlpb-stat" :class="{ 'twlpb-stat--overworked': isOverWorked }">
                <div class="twlpb-stat__number">
                    <span :style="timeLeftStyle">{{ timeLeft }}</span>
                </div>

                <div class="twlpb-stat__title">
                    <span :style="fitTextStyle(trans('Status'))">{{ trans('Status') }}</span>
                </div>
            </div>
        </div>
        <!--/ row -->

        <div class="twlpb-container" :class="{ 'twlpb-has-tooltip': isTooltipActive }">
            <div class="twlpb-time-full" :style="{ width: timeEstimatedWidth }">
                <div class="twlpb-time-planned" :style="{ width: timePlannedWidth }"></div>

                <div
                    class="twlpb-time-worked"
                    :class="{ 'is-overworked': isOverWorked }"
                    :style="{ width: timeWorkedWidth }"
                ></div>
            </div>

            <!-- <span class="twlpb-title twlpb-estimated"
                  v-if="isTooltipActive">
                {{ timeEstimated }}
            </span>-->
        </div>
    </div>
</template>

<script>
let cancel;

export default {
    name: 'TaskWorkLogProgressBar',
    data() {
        return {
            estimated: this.parseMinutes(this.task_estimated),
            planned: this.parseMinutes(this.task_planned),
            worked: this.parseMinutes(this.task_worked),
            percentage: 1,
            popupTimer: null,
            fittyTimer: null,
            isFittyApplied: false,
            stats: {
                isActive: false,
                isVisible: false,
                verticalAlignment: 1,
            },
            loadData: false,
        };
    },
    props: {
        taskId: {
            required: false,
            type: Number,
        },
        task_estimated: {
            required: false,
            type: [Number, String],
            default: 0,
        },
        task_planned: {
            required: false,
            type: [Number, String],
            default: 0,
        },
        task_worked: {
            required: false,
            type: [Number, String],
            default: 0,
        },
        isTitlesActive: {
            required: false,
            type: Boolean,
            default: true,
        },
        isTooltipActive: {
            required: false,
            type: Boolean,
            default: false,
        },
        isVisible: {
            required: false,
            type: Boolean,
            default: false,
        },
        isLoaded: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getWorkLog() {
            if (!this.taskId) return;
            this.loadData = true;
            var url = route('project.task.work-log', this.taskId);

            axios
                .get(url, {
                    cancelToken: new axios.CancelToken(function executor(c) {
                        // An executor function receives a cancel function as a parameter
                        cancel = c;
                    }),
                })
                .then((response) => {
                    this.estimated = this.parseMinutes(response.data.estimated_time);
                    this.planned = this.parseMinutes(response.data.planned);
                    this.worked = this.parseMinutes(response.data.worked);
                    this.loadData = false;
                })
                .catch((response) => {
                    this.loadData = false;
                });
        },
        parseMinutes(minutes) {
            return !isNaN(parseInt(minutes)) ? parseInt(minutes) : 0;
        },
        onMouseOver(event) {
            const self = this;

            if (!self.isVisible) {
                return;
            }

            let $target = jQuery(event.target),
                $container = $target.closest('.task-work-log-container'),
                cty = $container.offset().top,
                cby = cty + $container.height(),
                tty = $target.offset().top,
                tby = tty + 341;

            // Get popup display side
            self.stats.verticalAlignment = cty < tty && cby < tby;

            self.stats.isActive = true;

            self.applyFitty();

            self.popupTimer = setTimeout(function () {
                self.stats.isVisible = true;
            }, 100);
        },
        onMouseLeave(event) {
            const self = this;

            self.stats.isActive = false;
            self.stats.isVisible = false;

            clearTimeout(self.fittyTimer);
            clearTimeout(self.popupTimer);
        },
        applyFitty() {
            const self = this;

            // if (self.isFittyApplied) {
            //     return;
            // }
            //
            // fitty('.twlpb-stat__number span')[0].unsubscribe();
            // fitty('.twlpb-stat__title span')[0].unsubscribe();
            //
            // self.fittyTimer = setTimeout(function () {
            //     fitty('.twlpb-stat__number span', {minSize: 1, maxSize: 28});
            //     fitty('.twlpb-stat__title span', {minSize: 1, maxSize: 11});
            //
            //     self.isFittyApplied = true;
            // }, 50);
        },
        fitTextStyle(text) {
            const characters = text.length;
            const scale = 70;
            const size = scale / characters;

            return {
                'white-space': 'nowrap',
                display: 'inline-block',
                'font-size': `${size}px`,
            };
        },
    },
    created() {
        this.getWorkLog();
    },
    mounted() {
        const self = this;

        self.isFittyApplied = false;

        self.percentage = self.estimated / 100;

        if (self.isTitlesActive) {
            self.applyFitty();
        }
    },
    watch: {
        task_estimated() {
            this.estimated = this.parseMinutes(this.task_estimated);
        },
        task_planned() {
            this.planned = this.parseMinutes(this.task_planned);
        },
        task_worked() {
            this.worked = this.parseMinutes(this.task_worked);
        },
        estimated(v) {
            const self = this;

            self.percentage = v / 100;

            self.isFittyApplied = false;
        },
        planned(v) {
            const self = this;

            self.isFittyApplied = false;
        },
        worked(v) {
            const self = this;

            self.isFittyApplied = false;
        },
        isVisible(value) {
            const self = this;

            if (value) {
                self.isFittyApplied = false;

                self.applyFitty();
            } else {
                self.isFittyApplied = false;

                clearTimeout(self.fittyTimer);

                if (self.isTooltipActive) {
                    self.stats.isVisible = false;
                    self.stats.isActive = false;
                }
            }
        },
        isLoaded(value) {
            if (value == true) {
                this.loadData = true;
                this.getWorkLog();
            }
        },
        taskId() {
            this.loadData = true;
            this.getWorkLog();
        },
    },
    beforeUnmount() {
        cancel && cancel();

        const self = this;

        self.isFittyApplied = false;

        clearTimeout(self.popupTimer);
        clearTimeout(self.fittyTimer);
    },
    computed: {
        timeEstimatedWidth() {
            const self = this;

            return `${100}%`;
        },
        timePlannedWidth() {
            const self = this;

            let width = 0;

            width = self.planned / self.percentage;

            if (width > 100) {
                width = 100;
            }

            return `${width}%`;
        },
        timeWorkedWidth() {
            const self = this;

            let width = 0;

            width = self.worked / self.percentage;

            if (width > 100) {
                width = 100;
            }

            return `${width}%`;
        },
        isOverWorked() {
            const self = this;

            return self.worked / self.percentage > 90;
        },
        timeWorked() {
            const self = this;

            let minutes = self.worked % 60;
            let hours = (self.worked - minutes) / 60;

            if (hours < 10 && hours >= 0) {
                hours = `0${hours}`;
            }

            minutes = Math.abs(minutes);

            if (minutes < 10) {
                minutes = `0${minutes}`;
            }

            return `${hours}:${minutes}`;
        },
        timePlanned() {
            const self = this;

            let planned = self.planned;

            let minutes = planned % 60;
            let hours = (planned - minutes) / 60;

            if (hours < 10 && hours >= 0) {
                hours = `0${hours}`;
            }

            minutes = Math.abs(minutes);

            if (minutes < 10) {
                minutes = `0${minutes}`;
            }

            return `${hours}:${minutes}`;
        },
        timeLeft() {
            const self = this;

            if (self.estimated === 0) {
                return '00:00';
            }

            let left = parseInt(self.estimated - self.worked);

            let minutes = left % 60;
            let hours = (left - minutes) / 60;

            if (hours < 10 && hours >= 0) {
                if (left < 0 && hours === 0) {
                    hours = `-0${hours}`;
                } else {
                    hours = `0${hours}`;
                }
            }

            minutes = Math.abs(minutes);

            if (minutes < 10) {
                minutes = `0${minutes}`;
            }

            return `${hours}:${minutes}`;
        },
        timeEstimated() {
            const self = this;

            let minutes = self.estimated % 60;
            let hours = (self.estimated - minutes) / 60;

            if (hours < 10 && hours >= 0) {
                hours = `0${hours}`;
            }

            minutes = Math.abs(minutes);

            if (minutes < 10) {
                minutes = `0${minutes}`;
            }

            return `${hours}:${minutes}`;
        },
        timeEstimatedStyle() {
            const characters = this.timeEstimated.length;
            const width = 69 * 1.5;
            const size = width / characters;

            return {
                'white-space': 'nowrap',
                display: 'inline-block',
                'font-size': `${size}px`,
            };
        },
        timePlannedStyle() {
            const characters = this.timePlanned.length;
            const width = 69 * 1.5;
            const size = width / characters;

            return {
                'white-space': 'nowrap',
                display: 'inline-block',
                'font-size': `${size}px`,
            };
        },
        timeWorkedStyle() {
            const characters = this.timeWorked.length;
            const width = 69 * 1.5;
            const size = width / characters;

            return {
                'white-space': 'nowrap',
                display: 'inline-block',
                'font-size': `${size}px`,
            };
        },
        timeLeftStyle() {
            const characters = this.timeLeft.length;
            const width = 69 * 1.5;
            const size = width / characters;

            return {
                'white-space': 'nowrap',
                display: 'inline-block',
                'font-size': `${size}px`,
            };
        },
    },
};
</script>
